import { Button } from '@/components/ui/button'
import { DateRangePicker } from '@/components/ui/DateRangePicker'
import { Switch } from '@/components/ui/switch'
import { Grain } from '@/models/quoteAnalytics'

const GRAINS: { value: Grain; label: string }[] = [
  { value: Grain.INDICATION, label: 'Indications' },
  { value: Grain.QUOTE, label: 'Quotes' },
]

export function QuoteAnalyticsFilters({
  grain,
  onGrain,
  dateFrom,
  dateTo,
  onDateRange,
  excludeTestOrgs,
  onExcludeTestOrgs,
}: {
  grain: Grain
  onGrain: (g: Grain) => void
  dateFrom: string
  dateTo: string
  onDateRange: (from: string, to: string) => void
  excludeTestOrgs: boolean
  onExcludeTestOrgs: (v: boolean) => void
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-4">
      <div className="flex gap-2">
        {GRAINS.map((g) => (
          <Button
            key={g.value}
            variant={grain === g.value ? 'default' : 'outline'}
            onClick={() => onGrain(g.value)}
          >
            {g.label}
          </Button>
        ))}
      </div>
      <DateRangePicker start={dateFrom} end={dateTo} onChange={(start, end) => onDateRange(start, end)} />
      <label className="flex cursor-pointer items-center gap-2 text-sm">
        <Switch checked={excludeTestOrgs} onCheckedChange={onExcludeTestOrgs} />
        Exclude test &amp; internal
      </label>
    </div>
  )
}
